import { GTM_AUTH_SOURCE } from '@hozana/tracking/constants'

import { PAGE } from 'routes/constants'

export enum AppActionTypes {
  ADD_FLASH = 'ADD_FLASH',
  DESTROY_FLASH = 'DESTROY_FLASH',
  OPEN_POPIN = 'OPEN_POPIN',
  CLOSE_POPIN = 'CLOSE_POPIN',
  CONFIRM = 'CONFIRM',
  TOGGLE_LANG_BAR = 'TOGGLE_LANG_BAR',
  ACCEPT_COOKIES = 'ACCEPT_COOKIES',
  OPEN_NAVIGATION = 'OPEN_NAVIGATION',
  CLOSE_NAVIGATION = 'CLOSE_NAVIGATION',
  ADD_PROMPT = 'ADD_PROMPT',
  UPDATE_PROMPT_STATE = 'UPDATE_PROMPT_STATE',
  UNMOUNT_PROMPT = 'UNMOUNT_PROMPT',
  HYDRATE = 'HYDRATE',
  SET_TITLE = 'SET_TITLE',
}

export enum QUERY_ACTION {
  INVITE = 'invite',
  JOIN = 'join',
  LOGIN = 'login',
  PRAY = 'pray',
  SHARE_MAIL_PUBLI = 'share-mail-publi',
  SHOW_FLASH = 'show-flash',
  TRACK = 'track',
}

/** Autentication source tracking in database (Cf. @hozana/tracking - AUTH_SOURCE for authentication source tracking through Analytics) */
export enum QUERY_AUTH_SOURCE {
  HEADER_LOGIN = 'header-login',
  HEADER_SIGNUP = 'header-signup',
  HOME_PAGE = 'home-page',
}
export const AUTH_SOURCE_EQUIVALENTS: Record<QUERY_AUTH_SOURCE, GTM_AUTH_SOURCE> = {
  [QUERY_AUTH_SOURCE.HEADER_LOGIN]: GTM_AUTH_SOURCE.HEADER_LOGIN,
  [QUERY_AUTH_SOURCE.HEADER_SIGNUP]: GTM_AUTH_SOURCE.HEADER_SIGNUP,
  [QUERY_AUTH_SOURCE.HOME_PAGE]: GTM_AUTH_SOURCE.HOME_PAGE,
}

export enum HEADER_ITEM {
  COMMUNITY_JOIN_BUTTONS = 'CommunityJoinButtons',
  DONATION = 'Donation',
  GO_BACK = 'GoBack',
  LOGO = 'Logo',
  LANGUAGE_ITEM_BLOCK = 'LanguageItemBlock',
  LOGIN_BUTTON = 'LoginButton',
  LOGIN_LINK = 'LoginLink',
  NAVIGATION_BUTTON = 'NavigationButton',
  SIGN_UP_BUTTON = 'SignupButton',
  TO_HOZANA_LINK = 'ToHozanaLink',
  TITLE_PAGE = 'TitlePage',
}

export const CONTENT_ID = 'content-id'
export const NAVIGATION_ID = 'navigation-id'
export const HEADER_ID = 'header-id'
export const NAVIGATION_CLASS = 'navigation-class'
export const POPOVER_CLASS = 'popover-class'

// Only one popin may be displayed in the same time
export const POPIN_ID = 'popin-id'
export const POPIN_TITLE_ID = 'popin-title-id'
export const POPIN_CONTAINER_ID = 'popin-container'
export const POPIN_OVERLAY_ID = 'popin-overlay'
export const POPIN_CLOSE_BUTTON_ID = 'popin-close-button'

export const enum DONATION_SOURCE {
  HEADER = 'header',
  MENU = 'menu',
  HOME_PAGE = 'home-page',
}

export const FULL_STATIC_PAGES: PAGE[] = [
  PAGE.COMMUNITY_LIST_SEO,
  PAGE.HOME,
  PAGE.COMMUNITY_WIDGET,
  PAGE.COMMUNITY_VIEW_LANDING,
]

export const JOBS_PAGE_LINK = 'https://www.welcometothejungle.com/fr/companies/hozana/jobs'
